import { render, staticRenderFns } from "./InfoMachineTranslation.vue?vue&type=template&id=541f4bc8&scoped=true&"
import script from "./InfoMachineTranslation.vue?vue&type=script&lang=js&"
export * from "./InfoMachineTranslation.vue?vue&type=script&lang=js&"
import style0 from "./InfoMachineTranslation.vue?vue&type=style&index=0&id=541f4bc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541f4bc8",
  null
  
)

export default component.exports